import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import translateIn from './assets/locales/id/translation.json'
import translateEng from './assets/locales/en/translation.json'
import translateJpn from './assets/locales/jpn/translation.json'
import { DefaultLanguage } from './utilities/check-language';

// const fallbackLng = [`${localStorage.getItem('language') !== 'en' ? localStorage.getItem('language') : 'en' }`];
const fallbackLng = [DefaultLanguage()];
const resources = {
  in: {
    translation: translateIn
  },
  en: {
    translation: translateEng
  },
  jpn: {
    translation: translateJpn
  },
};

i18n
  .use(Backend) // load translations using http (default public/assets/locals/en/translations)
  .use(initReactI18next) // pass the i18n instance to react-i18next.
  .init({
    resources,
    fallbackLng, // fallback language is english.
    // lng: "id",
    detection: {
      checkWhitelist: true, // options for language detection
    },

    debug: false,

    interpolation: {
      escapeValue: false, // no need for react. it escapes by default
    },
  });

export default i18n;